import actions from './actions';
import getters from './getters';
import { marketReportStatus, recentListingStatus } from '../_config';
// const ModuleName = 'snapshot';
//  Initially state data 
function initState() {
    return {
        // isSearchInit: false, // md-search  Is the initialization completed? 
        listingStatus: [], // listing status  the list 
        listing: [], // listing  listings 
        marketReport: {}, //  obtained by the server  market report  data 
        // market report The state the module is in 
        fetchMarketReportStatus: marketReportStatus.coming,
        //  real estate recent listing The state the module is in 
        fetchListingStatus: recentListingStatus.coming,
        currentListingStatus: '', //  currently selected listingStatus
        currentListingStatusName: '', //  currently selected listingStatus of name value ， for display 
        //  pagination parameters 
        totalPage: 0,
        pageSize: 5,
        pageNum: 1,
        // more btn
        // moreBtnTitle: 'Request More Market Insights',
        // moreBtnStyle: {},
        // custom recent listing title
        // customListingTitle: 'Recent Listings',
        showListingPrice: true, //  Do you need to display listing price
        showSoldPrice: true, //  Do you need to display sold listing price
        searchParams: {}
    };
}
export default {
    state: initState,
    getters,
    actions
};
